import { DIETARY_ATTRIBUTES } from '../../../../views/phone-answering/constants';

export default {
  [DIETARY_ATTRIBUTES.DAIRY_FREE]: 'Maidoton',
  [DIETARY_ATTRIBUTES.HALAL]: 'Halal',
  [DIETARY_ATTRIBUTES.SPICY]: 'Tulinen',
  [DIETARY_ATTRIBUTES.VEGAN]: 'Vegaaninen',
  [DIETARY_ATTRIBUTES.GLUTEN_FREE]: 'Gluteeniton',
  [DIETARY_ATTRIBUTES.VEGETARIAN]: 'Kasvisruoka',
};
